import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import useSound from 'use-sound'; // 사운드 라이브러리 추가
import Home from './components/Home';
import Test from './components/Test';
import Loading from './components/Loading';
import Result from './components/Result';
import { analyzeResult } from './logic/analyzer';

// [사운드 설정] 배경음악 파일 경로 (public/sounds/bgm.mp3)
const BGM_URL = '/sounds/bgm.mp3';

function App() {
  // 1. 상태 관리
  const [mode, setMode] = useState('HOME'); 
  const [scores, setScores] = useState({ E: 0, S: 0, I: 0, W: 0 });
  const [resultAnimal, setResultAnimal] = useState(null);

  // 2. [사운드 로직] BGM 재생 함수 선언
  // loop: true (반복 재생), volume: 0.5 (중간 볼륨)
  const [playBgm] = useSound(BGM_URL, { 
    loop: true, 
    volume: 0.5 
  });

  // 3. 핸들러 함수들
  const handleStart = () => {
    playBgm(); // [에픽 연출] 시작 버튼을 누르는 순간 BGM이 시작됩니다.
    setMode('TEST');
  };

  const handleAnswer = (type, weight) => {
    setScores(prev => ({ ...prev, [type]: prev[type] + weight }));
  };

  const handleComplete = () => {
    const animalKey = analyzeResult(scores);
    setResultAnimal(animalKey);
    setMode('LOADING');

    setTimeout(() => {
      setMode('RESULT');
    }, 4000);
  };

  // 4. 애니메이션 설정
  const blackHoleVariant = {
    initial: { opacity: 0, scale: 1.5, filter: 'blur(20px)' },
    animate: { opacity: 1, scale: 1, filter: 'blur(0px)' },
    exit: { 
      opacity: 0, 
      scale: 0.1, 
      filter: 'blur(10px)',
      rotate: 45 
    }
  };

  // 5. 화면 렌더링
  return (
    <div style={{ backgroundColor: '#000', minHeight: '100vh', overflow: 'hidden' }}>
      <AnimatePresence mode="wait">
        
        {/* [HOME] 메인 화면 */}
        {mode === 'HOME' && (
          <motion.div
            key="home"
            variants={blackHoleVariant}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.8, ease: "easeInOut" }}
          >
            {/* handleStart를 전달하여 클릭 시 소리가 나도록 함 */}
            <Home onStart={handleStart} />
          </motion.div>
        )}

        {/* [TEST] 질문 화면 */}
        {mode === 'TEST' && (
          <motion.div
            key="test"
            variants={blackHoleVariant}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.8 }}
          >
            <Test onAnswer={handleAnswer} onComplete={handleComplete} />
          </motion.div>
        )}

        {/* [LOADING] 분석 화면 */}
        {mode === 'LOADING' && (
          <motion.div
            key="loading"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, scale: 2 }}
            transition={{ duration: 1 }}
          >
            <Loading />
          </motion.div>
        )}

        {/* [RESULT] 결과 화면 */}
        {mode === 'RESULT' && (
          <motion.div
            key="result"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <Result animalKey={resultAnimal} />
          </motion.div>
        )}

      </AnimatePresence>
    </div>
  );
}

export default App;